var map = {
	"./img/3m-mobile.webp": 1379,
	"./img/3m-mobile@2x.webp": 1380,
	"./img/RTU-MIREA.webp": 1381,
	"./img/ab-test/conference-room.webp": 1382,
	"./img/ab-test/conference-room@2x.webp": 1383,
	"./img/ab-test/for-record-1.webp": 1384,
	"./img/ab-test/for-record-1@2x.webp": 1385,
	"./img/ab-test/for-record-2.webp": 1386,
	"./img/ab-test/for-record-2@2x.webp": 1387,
	"./img/ab-test/for-record-3.webp": 1388,
	"./img/ab-test/for-record-3@2x.webp": 1389,
	"./img/ab-test/for-record-4.webp": 1390,
	"./img/ab-test/for-record-4@2x.webp": 1391,
	"./img/ab-test/for-studying-1.webp": 1392,
	"./img/ab-test/for-studying-1@2x.webp": 1393,
	"./img/ab-test/for-studying-2.webp": 1394,
	"./img/ab-test/for-studying-2@2x.webp": 1395,
	"./img/ab-test/for-studying-3.webp": 1396,
	"./img/ab-test/for-studying-3@2x.webp": 1397,
	"./img/ab-test/for-studying-4.webp": 1398,
	"./img/ab-test/for-studying-4@2x.webp": 1399,
	"./img/ab-test/for-studying-5.webp": 1400,
	"./img/ab-test/for-studying-5@2x.webp": 1401,
	"./img/ab-test/google-calendar.webp": 1402,
	"./img/ab-test/google-calendar@2x.webp": 1403,
	"./img/ab-test/outlook.webp": 1404,
	"./img/ab-test/outlook@2x.webp": 1405,
	"./img/about-service/img_1.webp": 1053,
	"./img/about-service/img_2.webp": 1144,
	"./img/about/Izobrazhenie_about.webp": 1406,
	"./img/about/about-promo-bg-900-599.webp": 1407,
	"./img/about/about-promo-bg.webp": 1408,
	"./img/about/about-promo-new-bg.webp": 1409,
	"./img/account/admin.webp": 1410,
	"./img/account/photo-1.webp": 1411,
	"./img/account/photo-2.webp": 1412,
	"./img/account/photo-3.webp": 1413,
	"./img/account/photo-4.webp": 1414,
	"./img/account/photo-main.webp": 1415,
	"./img/application-mts/chat-desktop.webp": 1148,
	"./img/application-mts/chat-mobile.webp": 1147,
	"./img/application-mts/link-desktop.webp": 1146,
	"./img/application-mts/link-mobile.webp": 1145,
	"./img/application-mts/promo.webp": 1416,
	"./img/articles/besplatnaja-komnata-dlja-webinarov.webp": 1417,
	"./img/articles/besplatnaja-programma-dlja-provedenija-i-prosmotra-webinarov.webp": 1418,
	"./img/articles/besplatnaja-programma-dlja-zapisi-webinarov-s-jekrana-so-zvukom.webp": 1419,
	"./img/articles/besplatnye-platformy-dlja-webinarov.webp": 1420,
	"./img/articles/besplatnye-ploshhadki-dlja-webinarov.webp": 1421,
	"./img/articles/besplatnye-webinary.webp": 1422,
	"./img/articles/besplatnyj-servis-dlja-provedenija-webinarov.webp": 1423,
	"./img/articles/celi-webinara.webp": 1424,
	"./img/articles/chto-nuzhno-dlja-webinara1.webp": 1425,
	"./img/articles/chto-nuzhno-dlja-webinara2.webp": 1426,
	"./img/articles/gde-najti-webinar-treningi-online.webp": 1427,
	"./img/articles/instrumenty-dlja-provedenija-webinarov.webp": 1428,
	"./img/articles/kak-mozhno-zapisat-online-webinar-na-computer.webp": 1429,
	"./img/articles/kak-organizovat-webinar-besplatno.webp": 1430,
	"./img/articles/kak-pravilno-podgotovitsja-k-webinaru.webp": 1431,
	"./img/articles/kak-privlech-ljudej-na-webinar.webp": 1432,
	"./img/articles/kak-provesti-svoj-pervyj-webinar.webp": 1433,
	"./img/articles/kak-provesti-webinar-besplatno.webp": 1434,
	"./img/articles/kak-provesti-webinar/add_conductor.webp": 1435,
	"./img/articles/kak-provesti-webinar/add_settings.webp": 1436,
	"./img/articles/kak-provesti-webinar/change1.webp": 1437,
	"./img/articles/kak-provesti-webinar/change2.webp": 1438,
	"./img/articles/kak-provesti-webinar/conductor.webp": 1439,
	"./img/articles/kak-provesti-webinar/confirm.webp": 1440,
	"./img/articles/kak-provesti-webinar/demo_webinar.webp": 1441,
	"./img/articles/kak-provesti-webinar/first_webinar.webp": 1442,
	"./img/articles/kak-provesti-webinar/invite1.webp": 1443,
	"./img/articles/kak-provesti-webinar/invite2.webp": 1444,
	"./img/articles/kak-provesti-webinar/landing.webp": 1445,
	"./img/articles/kak-provesti-webinar/loading_files.webp": 1446,
	"./img/articles/kak-provesti-webinar/more_information.webp": 1447,
	"./img/articles/kak-provesti-webinar/registration.webp": 1448,
	"./img/articles/kak-provesti-webinar/remind.webp": 1449,
	"./img/articles/kak-provesti-webinar/settings_information.webp": 1450,
	"./img/articles/kak-provesti-webinar/tags.webp": 1451,
	"./img/articles/kak-reklamirovat-i-prodvigat-webinar.webp": 1452,
	"./img/articles/kak-reklamirovat-i-prodvigat-webinar2.webp": 1453,
	"./img/articles/kak-sdelat-webinar.webp": 1454,
	"./img/articles/kak-skachat-video-s-online-webinara-na-computer-2.webp": 1455,
	"./img/articles/kak-skachat-video-s-online-webinara-na-computer.webp": 1456,
	"./img/articles/kak-sohranit-video-s-webinara-na-computer.webp": 1457,
	"./img/articles/kak-sozdat-vebinar-v-lokalnoj-seti.webp": 1458,
	"./img/articles/kak-sozdat-webinar-besplatno.webp": 1459,
	"./img/articles/kak-sozdat-webinar-na-svoem-saite.webp": 1460,
	"./img/articles/kak-ustanovit-webinar-na-komputer.webp": 1461,
	"./img/articles/kak-vybrat-ploschadku-dlja-provodenija-webinarov1.webp": 1462,
	"./img/articles/kak-vybrat-ploschadku-dlja-provodenija-webinarov2.webp": 1463,
	"./img/articles/kak-zapisat-webinar-s-ekrana.webp": 1464,
	"./img/articles/kak-zapisat-webinar-s-jekrana-kompjutera-so-zvukom-besplatno.webp": 1465,
	"./img/articles/kak-zapisat-webinar.webp": 1466,
	"./img/articles/kakie-naushniki-dlja-webinarov-vybrat.webp": 1467,
	"./img/articles/kakie-programmy-dlja-zapisi-webinara-luchshe-ispolzovat.webp": 1468,
	"./img/articles/koporativnye-webinary.webp": 1469,
	"./img/articles/lending-dlja-vebinarov.webp": 1470,
	"./img/articles/lidogeneracija-na-webinar.webp": 1471,
	"./img/articles/metodika-i-reglament-provedenija-webinara.webp": 1472,
	"./img/articles/obuchenie-provedeniju-i-forme-webinara.webp": 1473,
	"./img/articles/online-konferencija.webp": 1474,
	"./img/articles/oplata-webinarov.webp": 1475,
	"./img/articles/plantaja-webinar-platforma.webp": 1476,
	"./img/articles/platnye-webinary.webp": 1477,
	"./img/articles/podgotovka-webinara.webp": 1478,
	"./img/articles/priglashenie-na-webinar.webp": 1479,
	"./img/articles/prodazhi-cherez-webinar.webp": 1480,
	"./img/articles/programma-dlja-organizacii-i-provedenija-webinarov-kakuju-vybrat1.webp": 1481,
	"./img/articles/programma-dlja-organizacii-i-provedenija-webinarov-kakuju-vybrat2.webp": 1482,
	"./img/articles/programma-dlja-prosmotra-webinarov-na-planshete.webp": 1483,
	"./img/articles/provedenie-effektivnyh-webinarov.webp": 1484,
	"./img/articles/quote.webp": 1054,
	"./img/articles/rassylka-dlja-webinara.webp": 1485,
	"./img/articles/sajty-besplatnyh-webinarov.webp": 1486,
	"./img/articles/sbor-ljudej-dlja-webinara.webp": 1487,
	"./img/articles/servis-dlja-provedenija-webinarov-online1.webp": 1488,
	"./img/articles/servis-dlja-provedenija-webinarov-online2.webp": 1489,
	"./img/articles/shablony-dlja-provedenija-webinara.webp": 1490,
	"./img/articles/skolko-stoit-webinar.webp": 1491,
	"./img/articles/soprovozhdenie-webinarov.webp": 1492,
	"./img/articles/transljacija-vebinara-v-rezhime-online.webp": 1493,
	"./img/articles/trening-po-provedeniju-webinarov.webp": 1494,
	"./img/articles/virtualnye-komnaty-dlya-webinarov.webp": 1495,
	"./img/articles/vnedrenie-webinarov.webp": 1496,
	"./img/articles/web-camera-dlja-webinarov.webp": 1497,
	"./img/articles/webinar-kak-rpavilno.webp": 1498,
	"./img/articles/webinary-online.webp": 1499,
	"./img/articles/webinary-personalu-besplatno.webp": 1500,
	"./img/askon-reply.webp": 1501,
	"./img/askon.webp": 1502,
	"./img/author-1-mobile.webp": 1503,
	"./img/author-1-mobile@2x.webp": 1504,
	"./img/author-1.webp": 1505,
	"./img/author-1@2x.webp": 1506,
	"./img/author-2-mobile.webp": 1507,
	"./img/author-2-mobile@2x.webp": 1508,
	"./img/author-2.webp": 1509,
	"./img/author-2@2x.webp": 1510,
	"./img/author-3-mobile.webp": 1511,
	"./img/author-3-mobile@2x.webp": 1512,
	"./img/author-3.webp": 1513,
	"./img/author-3@2x.webp": 1514,
	"./img/author-4-mobile.webp": 1515,
	"./img/author-4-mobile@2x.webp": 1516,
	"./img/author-4.webp": 1517,
	"./img/author-4@2x.webp": 1518,
	"./img/author-5-mobile.webp": 1519,
	"./img/author-5-mobile@2x.webp": 1520,
	"./img/author-5.webp": 1521,
	"./img/author-5@2x.webp": 1522,
	"./img/author-6-mobile.webp": 1523,
	"./img/author-6-mobile@2x.webp": 1524,
	"./img/author-6.webp": 1525,
	"./img/author-6@2x.webp": 1526,
	"./img/avito-mobile.webp": 1527,
	"./img/avito-mobile@2x.webp": 1528,
	"./img/balta-mobile.webp": 1529,
	"./img/balta-mobile@2x.webp": 1530,
	"./img/bg-clients-1-mobile.webp": 1531,
	"./img/bg-clients-2-mobile.webp": 1532,
	"./img/bg-clients.webp": 1533,
	"./img/bg-control.webp": 1534,
	"./img/bg-ecosystem.webp": 1535,
	"./img/bg-efficiency-mark.webp": 1536,
	"./img/bg-experience.webp": 1537,
	"./img/bg-faq.webp": 1538,
	"./img/bg-multilingualism-mobile.webp": 1539,
	"./img/bg-multilingualism.webp": 1540,
	"./img/bg-online-learning.webp": 1541,
	"./img/bg-platform.webp": 1542,
	"./img/bg-prom-mobile.webp": 1543,
	"./img/bg-prom-mobile@2x.webp": 1544,
	"./img/bg-prom@2x.webp": 1545,
	"./img/bg-promo-meetings-mobile.webp": 1546,
	"./img/bg-promo-meetings.webp": 1547,
	"./img/bg-promo-three-mobile.webp": 1548,
	"./img/bg-promo-three-mobile_2x.webp": 1549,
	"./img/bg-promo-three.webp": 1550,
	"./img/bg-promo-three@2x.webp": 1551,
	"./img/bg-promo-webinar-mobile.webp": 1552,
	"./img/bg-promo-webinar.webp": 1553,
	"./img/bg-promo.webp": 1554,
	"./img/bg-registration.webp": 1555,
	"./img/bg-tasks.webp": 1556,
	"./img/bg-white.webp": 1557,
	"./img/bill/product-detail-marketing-promo-bg-mobile.webp": 585,
	"./img/bill/product-detail-marketing-promo-bg.webp": 584,
	"./img/bitrix-mobile.webp": 1558,
	"./img/bitrix-mobile@2x.webp": 1559,
	"./img/brochure/avatar-1.webp": 1560,
	"./img/brochure/avatar-2.webp": 1561,
	"./img/brochure/avatar-3.webp": 1562,
	"./img/brochure/avatar-4.webp": 1563,
	"./img/brochure/avatar-5.webp": 1564,
	"./img/brochure/brochure-check.webp": 1565,
	"./img/brochure/brochure-gradient-promo-bg.webp": 1058,
	"./img/brochure/brochure-magazine.webp": 1566,
	"./img/brochure/brochure-promo-bg.webp": 1567,
	"./img/brochure/brochure-promo-image.webp": 1568,
	"./img/brochure/brochure-sratistic.webp": 1569,
	"./img/brochure/kak-vybrat-platformu.webp": 1570,
	"./img/brochure/kak-zarabatyvat-na-webinarah.webp": 1571,
	"./img/brochure/review-avatar.webp": 1572,
	"./img/browsers/chrome.webp": 1573,
	"./img/browsers/firefox.webp": 1574,
	"./img/browsers/ie.webp": 1575,
	"./img/browsers/opera.webp": 1576,
	"./img/browsers/safari.webp": 1577,
	"./img/browsers/yandex.webp": 1578,
	"./img/categories/skin-1.webp": 1163,
	"./img/categories/skin-2.webp": 1159,
	"./img/categories/skin-4.webp": 1166,
	"./img/categories/skin-5.webp": 1169,
	"./img/categories/skin-6.webp": 1172,
	"./img/categories/skin-7.webp": 1174,
	"./img/categories/skin-8.webp": 1154,
	"./img/choose-platform/brochure-check.webp": 1579,
	"./img/choose-platform/brochure-promo-bg.webp": 1580,
	"./img/choose-platform/brochure-statistic.webp": 1581,
	"./img/choose-platform/kak-vybrat-platformu.webp": 1582,
	"./img/clients-items/alfa_bank/alfa-bank-1.webp": 1060,
	"./img/clients-items/amplua_broker/amplua-broker-bg.webp": 1061,
	"./img/clients-items/bittner_farma/bittner-farma-1.webp": 1062,
	"./img/clients-items/close.webp": 501,
	"./img/clients-items/completo/completo-1.webp": 721,
	"./img/clients-items/completo/completo-bg.webp": 1063,
	"./img/clients-items/completo/completo-review-avatar.webp": 473,
	"./img/clients-items/faberlic/faberlic-bg.webp": 1064,
	"./img/clients-items/fokus_media/fokus-media-1.webp": 1583,
	"./img/clients-items/foodik/foodik-bg.webp": 1065,
	"./img/clients-items/hansa/hansa-1.webp": 1066,
	"./img/clients-items/hansa/hansa-2.webp": 1067,
	"./img/clients-items/hansa/hansa-bg.webp": 1068,
	"./img/clients-items/hansa/hansa-icon-1.webp": 1069,
	"./img/clients-items/hansa/hansa-icon-2.webp": 722,
	"./img/clients-items/hansa/hansa-icon-3.webp": 1070,
	"./img/clients-items/hansa/hansa-icon-4.webp": 1071,
	"./img/clients-items/hansa/hansa-icon-5.webp": 1072,
	"./img/clients-items/hansa/hansa-icon-6.webp": 1073,
	"./img/clients-items/hansa/hansa-icon-7.webp": 1074,
	"./img/clients-items/hansa/hansa-icon-8.webp": 1075,
	"./img/clients-items/hansa/hansa-icon-9.webp": 1076,
	"./img/clients-items/ilearney/ilearney-1.webp": 1584,
	"./img/clients-items/lenovo/lenovo-1.webp": 1585,
	"./img/clients-items/lenovo/lenovo-2.webp": 1586,
	"./img/clients-items/lenovo/lenovo-3.webp": 1587,
	"./img/clients-items/lenovo/lenovo-4.webp": 1588,
	"./img/clients-items/lenovo/lenovo-5.webp": 1589,
	"./img/clients-items/lenovo/lenovo-bg-content-1.webp": 1590,
	"./img/clients-items/lenovo/lenovo-bg-content-2.webp": 1591,
	"./img/clients-items/lenovo/lenovo-bg-content-3.webp": 1592,
	"./img/clients-items/lenovo/lenovo-bg.webp": 1593,
	"./img/clients-items/lenovo/lenovo-logo.webp": 1594,
	"./img/clients-items/lenovo/lenovo-review-avatar.webp": 1595,
	"./img/clients-items/mgu/mgu-1.webp": 1077,
	"./img/clients-items/mgu/mgu-bg.webp": 1078,
	"./img/clients-items/mgu/mgu-review-avatar.webp": 518,
	"./img/clients-items/mgu/mgu-video-poster.webp": 1596,
	"./img/clients-items/midea/midea-1.webp": 1079,
	"./img/clients-items/midea/midea-bg.webp": 1080,
	"./img/clients-items/midea/midea-icon-1.webp": 1081,
	"./img/clients-items/midea/midea-icon-2.webp": 1082,
	"./img/clients-items/midea/midea-icon-3.webp": 1083,
	"./img/clients-items/midea/midea-review-avatar.webp": 723,
	"./img/clients-items/qiwi/qiwi-bg.webp": 1597,
	"./img/clients-items/review-bg.webp": 502,
	"./img/clients-items/rudn/rudn-1.webp": 1084,
	"./img/clients-items/see-also/fokus-media-logo.webp": 503,
	"./img/clients-items/see-also/fokus-media-skin.webp": 504,
	"./img/clients-items/see-also/ilearney-logo.webp": 523,
	"./img/clients-items/see-also/ilearney-skin.webp": 524,
	"./img/clients-items/see-also/lenovo-logo.webp": 505,
	"./img/clients-items/see-also/lenovo-skin.webp": 506,
	"./img/clients-items/see-also/rudn-logo.webp": 1598,
	"./img/clients-items/see-also/rudn-skin.webp": 1599,
	"./img/clients-items/siemens/siemens-bg.webp": 1085,
	"./img/clients/client-schuco.webp": 1600,
	"./img/clients/client-schuco@2x.webp": 1601,
	"./img/clients/clients-3m.webp": 1602,
	"./img/clients/clients-3m@2x.webp": 1603,
	"./img/clients/clients-avito.webp": 1604,
	"./img/clients/clients-avito@2x.webp": 1605,
	"./img/clients/clients-bitrix.webp": 1606,
	"./img/clients/clients-bitrix@2x.webp": 1607,
	"./img/clients/clients-manpower.webp": 1608,
	"./img/clients/clients-manpower@2x.webp": 1609,
	"./img/clients/clients-martinex.webp": 1610,
	"./img/clients/clients-mirea.webp": 1611,
	"./img/clients/clients-otkrytie.webp": 1612,
	"./img/clients/clients-otkrytie@2x.webp": 1613,
	"./img/clients/clients-renessans.webp": 1614,
	"./img/clients/clients-renessans@2x.webp": 1615,
	"./img/clients/clients-rusagro.webp": 1616,
	"./img/clients/clients-rusagro@2x.webp": 1617,
	"./img/clients/clients-valta.webp": 1618,
	"./img/contacts/contacts--promo.webp": 1149,
	"./img/contacts/contacts-photo.webp": 1055,
	"./img/contacts/product-detail-promo-bg.webp": 1619,
	"./img/contacts/way-type-car-black.webp": 1620,
	"./img/contacts/way-type-car-white.webp": 1621,
	"./img/contacts/way-type-foot-black.webp": 1622,
	"./img/contacts/way-type-foot-white.webp": 1623,
	"./img/content-page-promo-bg.webp": 475,
	"./img/control-1-760.webp": 1624,
	"./img/control-1-760@2x.webp": 1625,
	"./img/control-1.webp": 1626,
	"./img/control-1@2x.webp": 1627,
	"./img/control-2-760.webp": 1628,
	"./img/control-2-760@2x.webp": 1629,
	"./img/control-2.webp": 1630,
	"./img/control-2@2x.webp": 1631,
	"./img/control-3-760.webp": 1632,
	"./img/control-3-760@2x.webp": 1633,
	"./img/control-3.webp": 1634,
	"./img/control-3@2x.webp": 1635,
	"./img/control-4-760.webp": 1636,
	"./img/control-4-760@2x.webp": 1637,
	"./img/control-4.webp": 1638,
	"./img/control-4@2x.webp": 1639,
	"./img/control-mobile-1.webp": 1640,
	"./img/control-mobile-1@2x.webp": 1641,
	"./img/control-mobile-2.webp": 1642,
	"./img/control-mobile-2@2x.webp": 1643,
	"./img/control-mobile-3.webp": 1644,
	"./img/control-mobile-3@2x.webp": 1645,
	"./img/control-mobile-4.webp": 1646,
	"./img/control-mobile-4@2x.webp": 1647,
	"./img/director-speech/director-speech-bg.webp": 1648,
	"./img/efficiency-mark-1.webp": 1649,
	"./img/efficiency-mark-1@2x.webp": 1650,
	"./img/efficiency-mark-2.webp": 1651,
	"./img/efficiency-mark-2@2x.webp": 1652,
	"./img/efficiency-mark-3.webp": 1653,
	"./img/efficiency-mark-3@2x.webp": 1654,
	"./img/efficiency-mark-4.webp": 1655,
	"./img/efficiency-mark-4@2x.webp": 1656,
	"./img/efficiency-mark-mobile-1.webp": 1657,
	"./img/efficiency-mark-mobile-1@2x.webp": 1658,
	"./img/efficiency-mark-mobile-2.webp": 1659,
	"./img/efficiency-mark-mobile-2@2x.webp": 1660,
	"./img/efficiency-mark-mobile-3.webp": 1661,
	"./img/efficiency-mark-mobile-3@2x.webp": 1662,
	"./img/efficiency-mark-mobile-4.webp": 1663,
	"./img/efficiency-mark-mobile-4@2x.webp": 1664,
	"./img/faq_and_support/support.webp": 1150,
	"./img/faq_and_support/support_2x.webp": 1665,
	"./img/functions/for-learning/data-handling-screen-1.webp": 1666,
	"./img/functions/for-learning/data-handling-screen-2.webp": 1667,
	"./img/functions/for-learning/easy-learn-photo.webp": 1668,
	"./img/functions/for-learning/fast-start-photo.webp": 1669,
	"./img/functions/for-learning/package-icon.webp": 1670,
	"./img/functions/for-learning/photo-main.webp": 1671,
	"./img/functions/for-learning/planning-screen.webp": 1672,
	"./img/functions/for-learning/polycom.webp": 1673,
	"./img/functions/for-learning/product-detail-promo-bg.webp": 1674,
	"./img/functions/for-learning/search.webp": 1675,
	"./img/functions/for-learning/webi-bot.webp": 1676,
	"./img/functions/for-marketing/arrow-big-2.webp": 1677,
	"./img/functions/for-marketing/ga.webp": 1678,
	"./img/functions/for-marketing/landings-bg.webp": 1679,
	"./img/functions/for-marketing/landings-screen-2.webp": 1680,
	"./img/functions/for-marketing/landings.webp": 1681,
	"./img/functions/for-marketing/payments-screen-12.webp": 1682,
	"./img/functions/for-marketing/payments-screen-13.webp": 1683,
	"./img/functions/for-marketing/payments-set.webp": 1684,
	"./img/functions/for-marketing/product-detail-marketing-promo-bg.webp": 1086,
	"./img/functions/for-marketing/statistic-screen-1.webp": 1685,
	"./img/functions/for-marketing/statistic-screen-2.webp": 1686,
	"./img/functions/for-marketing/statistic.webp": 1687,
	"./img/functions/for-marketing/statistics-mask-l.webp": 1688,
	"./img/functions/for-marketing/statistics-mask-r.webp": 1689,
	"./img/functions/for-marketing/statistics.webp": 1690,
	"./img/functions/for-marketing/video-editor-bg.webp": 1691,
	"./img/functions/for-marketing/video-editor-screen.webp": 1692,
	"./img/functions/for-meetings/product-detail-meeting-promo-bg.webp": 1693,
	"./img/functions/for-meetings/statistic-screen-3.webp": 1694,
	"./img/functions/for-meetings/statistic-screen-4.webp": 1695,
	"./img/functions/for-meetings/statistic-screen-5.webp": 1696,
	"./img/functions/product-detail-broadcasting-bg.webp": 1056,
	"./img/functions/product-detail-promo-bg-900-591.webp": 1176,
	"./img/functions/product-detail-promo-bg.webp": 517,
	"./img/icon-balta-mobile.webp": 1697,
	"./img/icon-balta.webp": 1698,
	"./img/icon-bitrix-mobile.webp": 1699,
	"./img/icon-bitrix.webp": 1700,
	"./img/icon-contur-mobile.webp": 1701,
	"./img/icon-contur.webp": 1702,
	"./img/icon-drager-mobile.webp": 1703,
	"./img/icon-drager.webp": 1704,
	"./img/icon-martinex-mobile.webp": 1705,
	"./img/icon-martinex.webp": 1706,
	"./img/icon-mirea-mobile.webp": 1707,
	"./img/icon-set/icon-set-24.webp": 1708,
	"./img/icon-set/icon-set-comments.webp": 1709,
	"./img/icon-set/icon-set-headphones.webp": 1710,
	"./img/icon-set/icon-set-mail.webp": 1711,
	"./img/icon-set/icon-set-phone.webp": 1712,
	"./img/icon-set/icon-set-point.webp": 1713,
	"./img/icon-set/icon-set-timer.webp": 1714,
	"./img/industry-healthcare/board_1.webp": 1715,
	"./img/industry-healthcare/board_2.webp": 1716,
	"./img/industry-healthcare/board_3.webp": 1717,
	"./img/industry-healthcare/board_4.webp": 1718,
	"./img/industry-healthcare/form-image.webp": 1719,
	"./img/industry-healthcare/image.webp": 1720,
	"./img/industry-healthcare/image_mobile.webp": 1721,
	"./img/industry-healthcare/integration_1.webp": 1722,
	"./img/industry-healthcare/integration_2.webp": 1723,
	"./img/industry-healthcare/integration_3.webp": 1724,
	"./img/industry-healthcare/know-more.webp": 1725,
	"./img/industry-healthcare/promo.webp": 1726,
	"./img/industry-healthcare/promo_mobile.webp": 1727,
	"./img/industry-healthcare/promo_tablet.webp": 1728,
	"./img/industry-healthcare/software_1.webp": 1729,
	"./img/industry-healthcare/software_2.webp": 1730,
	"./img/integrations.webp": 1731,
	"./img/interface/android.webp": 1732,
	"./img/interface/apple.webp": 1733,
	"./img/interface/hd.webp": 1734,
	"./img/interface/interface-screen-1.webp": 1735,
	"./img/interface/interface-screen-10.webp": 1736,
	"./img/interface/interface-screen-11.webp": 1737,
	"./img/interface/interface-screen-12.webp": 1738,
	"./img/interface/interface-screen-13.webp": 1739,
	"./img/interface/interface-screen-14.webp": 1740,
	"./img/interface/interface-screen-2.webp": 1741,
	"./img/interface/interface-screen-3.webp": 1742,
	"./img/interface/interface-screen-4.webp": 1743,
	"./img/interface/interface-screen-5.webp": 1151,
	"./img/interface/interface-screen-6.webp": 1152,
	"./img/interface/interface-screen-7.webp": 1153,
	"./img/interface/interface-screen-8.webp": 1744,
	"./img/interface/interface-screen-9.webp": 1745,
	"./img/kontur-mobile.webp": 1746,
	"./img/kontur-mobile@2x.webp": 1747,
	"./img/logo/LenovoLogo-REV-White.webp": 1748,
	"./img/logo/company-5.webp": 1749,
	"./img/logo/logo-alfadirekt.webp": 1170,
	"./img/logo/logo-amplua.webp": 1171,
	"./img/logo/logo-bittner-farma.webp": 1164,
	"./img/logo/logo-completo.webp": 1175,
	"./img/logo/logo-de-puy-synthes.webp": 1750,
	"./img/logo/logo-department-it-moscow.webp": 1751,
	"./img/logo/logo-faberlic.webp": 1165,
	"./img/logo/logo-focus-media.webp": 1173,
	"./img/logo/logo-foodik.webp": 1156,
	"./img/logo/logo-ilearney.webp": 1167,
	"./img/logo/logo-leader-team.webp": 1168,
	"./img/logo/logo-lenovo.webp": 1155,
	"./img/logo/logo-mgu_dark.webp": 1162,
	"./img/logo/logo-moscow-business-school.webp": 1161,
	"./img/logo/logo-mosgortelecom.webp": 1752,
	"./img/logo/logo-platezhnye-sistemy-qiwi.webp": 1753,
	"./img/logo/logo-qiwi.webp": 1157,
	"./img/logo/logo-rudn.webp": 1160,
	"./img/logo/logo-siemens.webp": 1158,
	"./img/main/main--advantages/tab-communication_1.webp": 1087,
	"./img/main/main--advantages/tab-communication_2.webp": 1088,
	"./img/main/main--advantages/tab-communication_3-1200.webp": 773,
	"./img/main/main--advantages/tab-communication_3.webp": 1089,
	"./img/main/main--advantages/tab-integration_1.webp": 1090,
	"./img/main/main--advantages/tab-integration_3.webp": 774,
	"./img/main/main--advantages/tab-intelligence-bg.webp": 775,
	"./img/main/main--advantages/tab-intelligence_1.webp": 1177,
	"./img/main/main--advantages/tab-quality-bg.webp": 776,
	"./img/main/main--advantages/tab-quality_1-1200.webp": 1091,
	"./img/main/main--advantages/tab-quality_1-1440.webp": 1092,
	"./img/main/main--advantages/tab-quality_1-320.webp": 1093,
	"./img/main/main--advantages/tab-quality_1-375.webp": 1094,
	"./img/main/main--advantages/tab-quality_1-580.webp": 1095,
	"./img/main/main--advantages/tab-quality_1-991.webp": 1096,
	"./img/main/main--advantages/tab-quality_1.webp": 1097,
	"./img/main/main--advantages/tab-quality_2.webp": 1098,
	"./img/main/main--advantages/tab-safety_1.webp": 777,
	"./img/main/main--advantages/tab-safety_2.webp": 778,
	"./img/main/main--advantages/tab-safety_3.webp": 779,
	"./img/main/main--advantages/tab-support_1.webp": 1099,
	"./img/main/main--advantages/tab-support_2-768.webp": 1100,
	"./img/main/main--advantages/tab-support_2-991.webp": 1178,
	"./img/main/main--advantages/tab-support_2.webp": 780,
	"./img/main/main--advantages/tab-support_3.webp": 1101,
	"./img/main/main--exp/people-1.webp": 1102,
	"./img/main/main--exp/people-2.webp": 1103,
	"./img/main/main--exp/people-3.webp": 1104,
	"./img/main/main--leader/leader_1.webp": 1179,
	"./img/main/main--leader/phone.webp": 1180,
	"./img/main/main--leader/slider_1.webp": 1181,
	"./img/main/main--leader/slider_2.webp": 1182,
	"./img/main/main--leader/slider_3.webp": 1183,
	"./img/main/main--leader/slider_4.webp": 1184,
	"./img/main/main--premise/premise_1.webp": 781,
	"./img/main/main--products/main-product-1-1200.webp": 1754,
	"./img/main/main--products/main-product-1.webp": 1755,
	"./img/main/main--products/main-product-2-1200.webp": 1756,
	"./img/main/main--products/main-product-2.webp": 1757,
	"./img/main/main--products/task-management.webp": 1758,
	"./img/main/main--reviews/reviews-author-1.webp": 1759,
	"./img/main/main--reviews/reviews-author-2.webp": 1760,
	"./img/main/main--reviews/reviews-author-3.webp": 1761,
	"./img/main/main--reviews/reviews-author-4.webp": 1762,
	"./img/main/main-promo-bg.webp": 782,
	"./img/management-1.webp": 1763,
	"./img/management-1@2x.webp": 1764,
	"./img/management-2.webp": 1765,
	"./img/management-2@2x.webp": 1766,
	"./img/management-3.webp": 1767,
	"./img/management-3@2x.webp": 1768,
	"./img/management-bg.webp": 1769,
	"./img/manpower-mobile.webp": 1770,
	"./img/manpower-mobile@2x.webp": 1771,
	"./img/meetings-cisco/author-review-obi.webp": 1772,
	"./img/meetings-cisco/author-review-tinkoff.webp": 1773,
	"./img/meetings-cisco/cisco-mobile.webp": 1774,
	"./img/meetings-cisco/cisco-mobile@2x.webp": 1775,
	"./img/meetings-cisco/cisco.webp": 1776,
	"./img/meetings-cisco/cisco@2x.webp": 1777,
	"./img/meetings-cisco/import-substitution-mobile.webp": 1778,
	"./img/meetings-cisco/import-substitution-mobile@2x.webp": 1779,
	"./img/meetings-cisco/import-substitution.webp": 1780,
	"./img/meetings-cisco/import-substitution@2x.webp": 1781,
	"./img/meetings-cisco/interface-mobile.webp": 1782,
	"./img/meetings-cisco/interface-mobile@2x.webp": 1783,
	"./img/meetings-cisco/interface.webp": 1784,
	"./img/meetings-cisco/interface@2x.webp": 1785,
	"./img/meetings-cisco/promo-mobile.webp": 1786,
	"./img/meetings-cisco/promo-mobile@2x.webp": 1787,
	"./img/meetings-cisco/promo.webp": 1788,
	"./img/meetings-cisco/promo@2x.webp": 1789,
	"./img/meetings-cisco/safety-mobile.webp": 1790,
	"./img/meetings-cisco/safety-mobile@2x.webp": 1791,
	"./img/meetings-cisco/safety.webp": 1792,
	"./img/meetings-cisco/safety@2x.webp": 1793,
	"./img/meetings-cisco/support-mobile.webp": 1794,
	"./img/meetings-cisco/support-mobile@2x.webp": 1795,
	"./img/meetings-cisco/support.webp": 1796,
	"./img/meetings-cisco/support@2x.webp": 1797,
	"./img/meetings-cisco/team-mobile.webp": 1798,
	"./img/meetings-cisco/team-mobile@2x.webp": 1799,
	"./img/meetings-cisco/team.webp": 1800,
	"./img/meetings-cisco/team@2x.webp": 1801,
	"./img/meetings-ms-teams/education-mobile.webp": 1802,
	"./img/meetings-ms-teams/education-mobile@2x.webp": 1803,
	"./img/meetings-ms-teams/education.webp": 1804,
	"./img/meetings-ms-teams/education@2x.webp": 1805,
	"./img/meetings-ms-teams/expansion-mobile.webp": 1806,
	"./img/meetings-ms-teams/expansion-mobile@2x.webp": 1807,
	"./img/meetings-ms-teams/expansion.webp": 1808,
	"./img/meetings-ms-teams/expansion@2x.webp": 1809,
	"./img/meetings-ms-teams/marketing-mobile.webp": 1810,
	"./img/meetings-ms-teams/marketing-mobile@2x.webp": 1811,
	"./img/meetings-ms-teams/marketing.webp": 1812,
	"./img/meetings-ms-teams/marketing@2x.webp": 1813,
	"./img/meetings-ms-teams/ms-teams-logo-mobile.webp": 1814,
	"./img/meetings-ms-teams/ms-teams-logo-mobile@2x.webp": 1815,
	"./img/meetings-ms-teams/ms-teams-logo.webp": 1816,
	"./img/meetings-ms-teams/ms-teams-logo@2x.webp": 1817,
	"./img/meetings-ms-teams/security-mobile.webp": 1818,
	"./img/meetings-ms-teams/security-mobile@2x.webp": 1819,
	"./img/meetings-ms-teams/security.webp": 1820,
	"./img/meetings-ms-teams/security@2x.webp": 1821,
	"./img/meetings-ms-teams/substitution-mobile.webp": 1822,
	"./img/meetings-ms-teams/substitution-mobile@2x.webp": 1823,
	"./img/meetings-ms-teams/substitution.webp": 1824,
	"./img/meetings-ms-teams/substitution@2x.webp": 1825,
	"./img/meetings-skype/expansion-mobile.webp": 1826,
	"./img/meetings-skype/expansion-mobile@2x.webp": 1827,
	"./img/meetings-skype/expansion.webp": 1828,
	"./img/meetings-skype/expansion@2x.webp": 1829,
	"./img/meetings-skype/marketing-mobile.webp": 1830,
	"./img/meetings-skype/marketing-mobile@2x.webp": 1831,
	"./img/meetings-skype/marketing.webp": 1832,
	"./img/meetings-skype/marketing@2x.webp": 1833,
	"./img/meetings-skype/meetings-skype-mobile.webp": 1834,
	"./img/meetings-skype/meetings-skype-mobile@2x.webp": 1835,
	"./img/meetings-skype/meetings-skype.webp": 1836,
	"./img/meetings-skype/meetings-skype@2x.webp": 1837,
	"./img/meetings-skype/onesolution-mobile.webp": 1838,
	"./img/meetings-skype/onesolution-mobile@2x.webp": 1839,
	"./img/meetings-skype/onesolution.webp": 1840,
	"./img/meetings-skype/onesolution@2x.webp": 1841,
	"./img/meetings-skype/perspectives-mobile.webp": 1842,
	"./img/meetings-skype/perspectives-mobile@2x.webp": 1843,
	"./img/meetings-skype/perspectives.webp": 1844,
	"./img/meetings-skype/perspectives@2x.webp": 1845,
	"./img/meetings-skype/perspectives_2x.webp": 1846,
	"./img/meetings-skype/security-mobile.webp": 1847,
	"./img/meetings-skype/security-mobile@2x.webp": 1848,
	"./img/meetings-skype/security.webp": 1849,
	"./img/meetings-skype/security@2x.webp": 1850,
	"./img/meetings-zoom/author-review-ackon.webp": 1851,
	"./img/meetings-zoom/author-review-timiryazeva.webp": 1852,
	"./img/meetings-zoom/author-review.webp": 1853,
	"./img/meetings-zoom/capabilities-mobile.webp": 1854,
	"./img/meetings-zoom/capabilities-mobile@2x.webp": 1855,
	"./img/meetings-zoom/capabilities.webp": 1856,
	"./img/meetings-zoom/capabilities@2x.webp": 1857,
	"./img/meetings-zoom/communication-mobile.webp": 1858,
	"./img/meetings-zoom/communication-mobile@2x.webp": 1859,
	"./img/meetings-zoom/communication.webp": 1860,
	"./img/meetings-zoom/communication@2x.webp": 1861,
	"./img/meetings-zoom/expansion-mobile.webp": 1862,
	"./img/meetings-zoom/expansion-mobile@2x.webp": 1863,
	"./img/meetings-zoom/expansion.webp": 1864,
	"./img/meetings-zoom/expansion@2x.webp": 1865,
	"./img/meetings-zoom/marketing-mobile.webp": 1866,
	"./img/meetings-zoom/marketing-mobile@2x.webp": 1867,
	"./img/meetings-zoom/marketing.webp": 1868,
	"./img/meetings-zoom/marketing@2x.webp": 1869,
	"./img/meetings-zoom/meetings-zoom-mobile.webp": 1870,
	"./img/meetings-zoom/meetings-zoom-mobile@2x.webp": 1871,
	"./img/meetings-zoom/meetings-zoom.webp": 1872,
	"./img/meetings-zoom/meetings-zoom@2x.webp": 1873,
	"./img/meetings-zoom/meetings-zoom_2x.webp": 1874,
	"./img/meetings-zoom/onesolution-mobile.webp": 1875,
	"./img/meetings-zoom/onesolution-mobile@2x.webp": 1876,
	"./img/meetings-zoom/onesolution.webp": 1877,
	"./img/meetings-zoom/onesolution@2x.webp": 1878,
	"./img/meetings-zoom/promo-mobile.webp": 1879,
	"./img/meetings-zoom/promo-mobile@2x.webp": 1880,
	"./img/meetings-zoom/promo.webp": 1881,
	"./img/meetings-zoom/promo@2x.webp": 1882,
	"./img/meetings-zoom/security-mobile.webp": 1883,
	"./img/meetings-zoom/security-mobile@2x.webp": 1884,
	"./img/meetings-zoom/security.webp": 1885,
	"./img/meetings-zoom/security@2x.webp": 1886,
	"./img/meetings/capabilities.webp": 1887,
	"./img/meetings/capabilities@2x.webp": 1888,
	"./img/meetings/communication-mobile.webp": 1889,
	"./img/meetings/communication-mobile@2x.webp": 1890,
	"./img/meetings/communication.webp": 1891,
	"./img/meetings/communication@2x.webp": 1892,
	"./img/meetings/expansion-mobile.webp": 1893,
	"./img/meetings/expansion-mobile@2x.webp": 1894,
	"./img/meetings/expansion.webp": 1895,
	"./img/meetings/expansion@2x.webp": 1896,
	"./img/meetings/marketing-mobile.webp": 1897,
	"./img/meetings/marketing-mobile@2x.webp": 1898,
	"./img/meetings/marketing.webp": 1899,
	"./img/meetings/marketing@2x.webp": 1900,
	"./img/meetings/onesolution-mobile.webp": 1901,
	"./img/meetings/onesolution-mobile@2x.webp": 1902,
	"./img/meetings/onesolution.webp": 1903,
	"./img/meetings/onesolution@2x.webp": 1904,
	"./img/meetings/promo-mobile.webp": 1905,
	"./img/meetings/promo-mobile@2x.webp": 1906,
	"./img/meetings/promo.webp": 1907,
	"./img/meetings/promo@2x.webp": 1908,
	"./img/meetings/security-mobile.webp": 1909,
	"./img/meetings/security-mobile@2x.webp": 1910,
	"./img/meetings/security.webp": 1911,
	"./img/meetings/security@2x.webp": 1912,
	"./img/multilingualism.webp": 1913,
	"./img/multilingualism@2x.webp": 1914,
	"./img/online-learning-1.webp": 1915,
	"./img/online-learning-1@2x.webp": 1916,
	"./img/online-learning-2.webp": 1917,
	"./img/online-learning-2@2x.webp": 1918,
	"./img/online-learning-3.webp": 1919,
	"./img/online-learning-3@2x.webp": 1920,
	"./img/online-learning-4.webp": 1921,
	"./img/online-learning-4@2x.webp": 1922,
	"./img/online-learning-5.webp": 1923,
	"./img/online-learning-5@2x.webp": 1924,
	"./img/online-learning-mobile-1.webp": 1925,
	"./img/online-learning-mobile-1@2x.webp": 1926,
	"./img/online-learning-mobile-2.webp": 1927,
	"./img/online-learning-mobile-2@2x.webp": 1928,
	"./img/online-learning-mobile-3.webp": 1929,
	"./img/online-learning-mobile-3@2x.webp": 1930,
	"./img/online-learning-mobile-4.webp": 1931,
	"./img/online-learning-mobile-4@2x.webp": 1932,
	"./img/online-learning-mobile-5.webp": 1933,
	"./img/online-learning-mobile-5@2x.webp": 1934,
	"./img/otkrytie-mobile.webp": 1935,
	"./img/otkrytie-mobile@2x.webp": 1936,
	"./img/paralax-content-mobile.webp": 1937,
	"./img/paralax-content.webp": 1938,
	"./img/paralax-mask-mobile.webp": 1939,
	"./img/paralax-mask.webp": 1940,
	"./img/partners-bg.webp": 1941,
	"./img/partners/contacts_desktop.webp": 1185,
	"./img/partners/contacts_mobile.webp": 1186,
	"./img/partners/contacts_tablet.webp": 1187,
	"./img/partners/how-img_1.webp": 1105,
	"./img/partners/how-img_2.webp": 1106,
	"./img/partners/promo_desktop.webp": 1188,
	"./img/partners/promo_mobile.webp": 1189,
	"./img/partners/promo_tablet.webp": 1190,
	"./img/platform.webp": 1942,
	"./img/platform/interface-mobile.webp": 1943,
	"./img/platform/interface-mobile@2x.webp": 1944,
	"./img/platform/interface.webp": 1945,
	"./img/platform/interface@2x.webp": 1946,
	"./img/platform/mobile-apps-bg-mobile.webp": 1947,
	"./img/platform/mobile-apps-bg.webp": 1948,
	"./img/platform/mobile-apps.webp": 1949,
	"./img/platform/mobile-apps@2x.webp": 1950,
	"./img/platform/platform-bg-mobile.webp": 1951,
	"./img/platform/platform-bg.webp": 1952,
	"./img/platform/platform.webp": 1953,
	"./img/platform/platform@2x.webp": 1954,
	"./img/platform@2x.webp": 1955,
	"./img/popup/popup-error.webp": 1956,
	"./img/popup/popup-success.webp": 1957,
	"./img/price.webp": 1958,
	"./img/products-comdi/capability-img_1.webp": 1325,
	"./img/products-comdi/capability-img_2.webp": 1326,
	"./img/products-comdi/capability-img_3.webp": 1327,
	"./img/products-comdi/capability-img_4.webp": 1107,
	"./img/products-comdi/capability-slider-img_1--mobile.webp": 1108,
	"./img/products-comdi/capability-slider-img_1.webp": 1328,
	"./img/products-comdi/capability-slider-img_2--mobile.webp": 1109,
	"./img/products-comdi/capability-slider-img_2.webp": 1329,
	"./img/products-comdi/capability-slider-img_3--mobile.webp": 1110,
	"./img/products-comdi/capability-slider-img_3.webp": 1330,
	"./img/products-comdi/form-img.webp": 1191,
	"./img/products-comdi/organization-img_1--mobile.webp": 1111,
	"./img/products-comdi/organization-img_1--tablet.webp": 1192,
	"./img/products-comdi/organization-img_1.webp": 1331,
	"./img/products-comdi/organization-img_2--mobile.webp": 1112,
	"./img/products-comdi/organization-img_2--tablet.webp": 1193,
	"./img/products-comdi/organization-img_2.webp": 1332,
	"./img/products-comdi/type-events-img_1--mobile.webp": 1113,
	"./img/products-comdi/type-events-img_1.webp": 1333,
	"./img/products-comdi/type-events-img_2--mobile.webp": 1114,
	"./img/products-comdi/type-events-img_2.webp": 1334,
	"./img/products-comdi/type-events-img_3--mobile.webp": 1115,
	"./img/products-comdi/type-events-img_3.webp": 1335,
	"./img/products-meetings/meetings--detail/1.webp": 1959,
	"./img/products-meetings/meetings--detail/2.webp": 1960,
	"./img/products-meetings/meetings--detail/3.webp": 1961,
	"./img/products-meetings/meetings--detail/4.webp": 1962,
	"./img/products-meetings/meetings--exp/anatoly_volkov.webp": 1336,
	"./img/products-meetings/meetings--exp/andrey_zhirkov.webp": 1337,
	"./img/products-meetings/meetings--exp/dmitry_starostov.webp": 1338,
	"./img/products-meetings/meetings--exp/reviews/author-1.webp": 1339,
	"./img/products-meetings/meetings--exp/reviews/author-2.webp": 1340,
	"./img/products-meetings/meetings--exp/reviews/author-3.webp": 1341,
	"./img/products-meetings/meetings--expand/boards.webp": 1963,
	"./img/products-meetings/meetings--expand/chats.webp": 1964,
	"./img/products-meetings/meetings--expand/forms.webp": 1965,
	"./img/products-meetings/meetings--form/form.webp": 1342,
	"./img/products-meetings/meetings--form/form_768.webp": 1343,
	"./img/products-meetings/meetings--form/form_992.webp": 1344,
	"./img/products-meetings/meetings--high-level/ai.webp": 1194,
	"./img/products-meetings/meetings--high-level/platform.webp": 1195,
	"./img/products-meetings/meetings--high-level/slider/1.webp": 1345,
	"./img/products-meetings/meetings--high-level/slider/2.webp": 1346,
	"./img/products-meetings/meetings--high-level/slider/3.webp": 1347,
	"./img/products-meetings/meetings--high-level/slider/4.webp": 1348,
	"./img/products-meetings/meetings--request-rooms/rooms_1.webp": 783,
	"./img/products-meetings/meetings--request-rooms/rooms_2.webp": 784,
	"./img/products-meetings/meetings--request-rooms/rooms_3.webp": 785,
	"./img/products-meetings/meetings--request-rooms/rooms_4.webp": 786,
	"./img/products-meetings/meetings--tariffs/tariff.webp": 1966,
	"./img/products-meetings/meetings--tariffs/tariff_375.webp": 1967,
	"./img/products-meetings/meetings--top/1440_top.webp": 1349,
	"./img/products-meetings/meetings--top/375_top.webp": 1350,
	"./img/products-meetings/meetings--top/768_top.webp": 1351,
	"./img/products-messenger/advantages_1.webp": 605,
	"./img/products-messenger/advantages_2.webp": 724,
	"./img/products-messenger/advantages_3-mobile.webp": 787,
	"./img/products-messenger/advantages_3.webp": 788,
	"./img/products-messenger/cases/author_chernogolovka.webp": 789,
	"./img/products-messenger/cases/author_default.webp": 790,
	"./img/products-messenger/cases/author_kantiana.webp": 791,
	"./img/products-messenger/communication_1.webp": 1116,
	"./img/products-messenger/communication_2.webp": 1117,
	"./img/products-messenger/communication_3.webp": 1118,
	"./img/products-messenger/form_1-mobile.webp": 792,
	"./img/products-messenger/form_1.webp": 793,
	"./img/products-messenger/just-start_1.webp": 1119,
	"./img/products-messenger/just-start_2.webp": 1120,
	"./img/products-messenger/just-start_3.webp": 1121,
	"./img/products-messenger/popup_1-768.webp": 794,
	"./img/products-messenger/popup_1-991.webp": 795,
	"./img/products-messenger/popup_1.webp": 796,
	"./img/products-on-premise/case-1-mobile.webp": 1196,
	"./img/products-on-premise/case-1-tablet.webp": 1197,
	"./img/products-on-premise/case-1.webp": 1198,
	"./img/products-on-premise/case-card-1-mobile.webp": 1968,
	"./img/products-on-premise/case-card-1.webp": 1969,
	"./img/products-on-premise/image_1.webp": 1199,
	"./img/products-on-premise/image_1_mobile.webp": 1200,
	"./img/products-on-premise/image_1_tablet.webp": 1201,
	"./img/products-on-premise/image_2.webp": 1202,
	"./img/products-on-premise/image_3.webp": 1203,
	"./img/products-on-premise/lock.webp": 1204,
	"./img/products-on-premise/safety.webp": 1205,
	"./img/products-on-premise/scheme_1.webp": 1206,
	"./img/products-on-premise/scheme_1_mobile.webp": 1207,
	"./img/products-on-premise/scheme_1_tablet.webp": 1208,
	"./img/products-on-premise/scheme_2.webp": 1209,
	"./img/products-on-premise/scheme_2_mobile.webp": 1210,
	"./img/products-on-premise/scheme_2_tablet.webp": 1211,
	"./img/products-on-premise/settings.webp": 1212,
	"./img/products-on-premise/slide_AI.webp": 1213,
	"./img/products-on-premise/slide_control.webp": 1214,
	"./img/products-on-premise/slide_groups.webp": 1215,
	"./img/products-on-premise/slide_logging.webp": 1216,
	"./img/products-on-premise/slide_waiting-room.webp": 1217,
	"./img/products-on-premise/sto.webp": 1218,
	"./img/products-on-premise/summary.webp": 1219,
	"./img/products-rooms/for_who_1.webp": 1220,
	"./img/products-rooms/for_who_1_mobile.webp": 1221,
	"./img/products-rooms/for_who_1_tablet.webp": 1222,
	"./img/products-rooms/for_who_2.webp": 1223,
	"./img/products-rooms/for_who_2_mobile.webp": 1224,
	"./img/products-rooms/for_who_2_tablet.webp": 1225,
	"./img/products-rooms/for_who_3.webp": 1226,
	"./img/products-rooms/for_who_3_mobile.webp": 1227,
	"./img/products-rooms/for_who_3_tablet.webp": 1228,
	"./img/products-rooms/for_who_icon.webp": 1229,
	"./img/products-rooms/gift_mobile.webp": 1230,
	"./img/products-rooms/icon_1.webp": 1231,
	"./img/products-rooms/icon_2.webp": 1232,
	"./img/products-rooms/icon_3.webp": 1233,
	"./img/products-rooms/image_1.webp": 1122,
	"./img/products-rooms/image_2.webp": 1234,
	"./img/products-rooms/image_2_mobile.webp": 1235,
	"./img/products-rooms/image_2_tablet.webp": 1236,
	"./img/products-rooms/image_3.webp": 1237,
	"./img/products-rooms/image_3_mobile.webp": 1238,
	"./img/products-rooms/image_3_tablet.webp": 1239,
	"./img/products-rooms/image_4.webp": 1240,
	"./img/products-rooms/photo_1.webp": 1241,
	"./img/products-rooms/photo_2.webp": 1242,
	"./img/products-rooms/photo_3.webp": 1243,
	"./img/products-rooms/photo_4.webp": 1244,
	"./img/products-rooms/video.webp": 1970,
	"./img/products-task-management/task-management--advantages/card-bg.webp": 1352,
	"./img/products-task-management/task-management--details/convenient-tool.webp": 1971,
	"./img/products-task-management/task-management--details/quick-search.webp": 1972,
	"./img/products-task-management/task-management--details/single-space.webp": 1973,
	"./img/products-task-management/task-management--details/time-saving.webp": 1974,
	"./img/products-task-management/task-management--form/form-bg--767.webp": 1245,
	"./img/products-task-management/task-management--form/form-bg--991.webp": 1246,
	"./img/products-task-management/task-management--form/form-bg.webp": 1353,
	"./img/products-task-management/task-management--promo/promo-bg--375.webp": 1247,
	"./img/products-task-management/task-management--promo/promo-bg--767.webp": 1248,
	"./img/products-task-management/task-management--promo/promo-bg.webp": 1354,
	"./img/products-webinars/cases/cases-author-1.webp": 1975,
	"./img/products-webinars/cases/cases-author-2.webp": 1976,
	"./img/products-webinars/cases/cases-author-3.webp": 1977,
	"./img/products-webinars/cases/cases-author-4.webp": 1978,
	"./img/products-webinars/cases/cases-author-5.webp": 1979,
	"./img/products-webinars/cases/cases-author-6.webp": 1980,
	"./img/products-webinars/cases/cases-logo-1.webp": 1981,
	"./img/products-webinars/cases/cases-logo-2.webp": 1982,
	"./img/products-webinars/cases/cases-logo-3.webp": 1983,
	"./img/products-webinars/cases/cases-logo-4.webp": 1984,
	"./img/products-webinars/cases/cases-logo-5.webp": 1985,
	"./img/products-webinars/cases/cases-logo-6.webp": 1986,
	"./img/products-webinars/devices_1_1920.webp": 1987,
	"./img/products-webinars/devices_1_375.webp": 1988,
	"./img/products-webinars/devices_1_768.webp": 1989,
	"./img/products-webinars/devices_2_1920.webp": 1990,
	"./img/products-webinars/devices_2_375.webp": 1991,
	"./img/products-webinars/devices_2_768.webp": 1992,
	"./img/products-webinars/link-on-premise-bg_1920.webp": 1993,
	"./img/products-webinars/link-on-premise-bg_375.webp": 1994,
	"./img/products-webinars/link-on-premise-bg_768.webp": 1995,
	"./img/products-webinars/webinaras_1_1920.webp": 1996,
	"./img/products-webinars/webinars--exp/reviews/author-1.webp": 1997,
	"./img/products-webinars/webinars--exp/reviews/author-2.webp": 1998,
	"./img/products-webinars/webinars--exp/reviews/author-3.webp": 1999,
	"./img/products-webinars/webinars--expand/1440 kurs.webp": 2000,
	"./img/products-webinars/webinars--expand/forms.webp": 2001,
	"./img/products-webinars/webinars--form/man--1199.webp": 1249,
	"./img/products-webinars/webinars--form/man--1320.webp": 1355,
	"./img/products-webinars/webinars--form/man--1920.webp": 1356,
	"./img/products-webinars/webinars--form/man--375.webp": 1250,
	"./img/products-webinars/webinars--form/man--580.webp": 1357,
	"./img/products-webinars/webinars--form/man--768.webp": 1358,
	"./img/products-webinars/webinars--form/man--980.webp": 1359,
	"./img/products-webinars/webinars--high-level/ai.webp": 2002,
	"./img/products-webinars/webinars--high-level/avtoveb.webp": 2003,
	"./img/products-webinars/webinars--high-level/doski.webp": 2004,
	"./img/products-webinars/webinars--high-level/test.webp": 2005,
	"./img/products-webinars/webinars--media/1.webp": 2006,
	"./img/products-webinars/webinars--tariffs/1200_tarif.webp": 2007,
	"./img/products-webinars/webinars--tariffs/1440_tarif.webp": 2008,
	"./img/products-webinars/webinars--tariffs/375 tarif.webp": 2009,
	"./img/products-webinars/webinars--tariffs/768 tarif.webp": 2010,
	"./img/products-webinars/webinars--top/1440_top.webp": 1360,
	"./img/products-webinars/webinars--top/768_top.webp": 1361,
	"./img/products-webinars/webinars-form__1920.webp": 2011,
	"./img/products-webinars/webinars_1_1920.webp": 2012,
	"./img/products-webinars/webinars_1_375.webp": 2013,
	"./img/products-webinars/webinars_1_768.webp": 2014,
	"./img/products-webinars/webinars_2_1920.webp": 2015,
	"./img/products-webinars/webinars_2_375.webp": 2016,
	"./img/products-webinars/webinars_3_1920.webp": 2017,
	"./img/products-webinars/webinars_3_375.webp": 2018,
	"./img/products-webinars/webinars_4_1920.webp": 2019,
	"./img/products-webinars/webinars_4_375.webp": 2020,
	"./img/products-webinars/webinars_5_1920.webp": 2021,
	"./img/products-webinars/webinars_5_375.webp": 2022,
	"./img/products-webinars/webinars_6_1920.webp": 2023,
	"./img/products-webinars/webinars_6_375.webp": 2024,
	"./img/products-webinars/webinars_7_1920.webp": 2025,
	"./img/products-webinars/webinars_7_375.webp": 2026,
	"./img/products-webinars/webinars_7_768.webp": 2027,
	"./img/products-webinars/webinars_8_1920.webp": 2028,
	"./img/registration-1.webp": 2029,
	"./img/registration-1@2x.webp": 2030,
	"./img/registration-2.webp": 2031,
	"./img/registration-2@2x.webp": 2032,
	"./img/registration-3-test.webp": 2033,
	"./img/registration-3.webp": 2034,
	"./img/registration-3@2x.webp": 2035,
	"./img/registration-4.webp": 2036,
	"./img/registration-4@2x.webp": 2037,
	"./img/registration-5.webp": 2038,
	"./img/registration-5@2x.webp": 2039,
	"./img/registration-6.webp": 2040,
	"./img/registration-6@2x.webp": 2041,
	"./img/registration-mobile-1.webp": 2042,
	"./img/registration-mobile-1@2x.webp": 2043,
	"./img/registration-mobile-2.webp": 2044,
	"./img/registration-mobile-2@2x.webp": 2045,
	"./img/registration-mobile-3.webp": 2046,
	"./img/registration-mobile-3@2x.webp": 2047,
	"./img/registration-mobile-4.webp": 2048,
	"./img/registration-mobile-4@2x.webp": 2049,
	"./img/registration-mobile-5.webp": 2050,
	"./img/registration-mobile-5@2x.webp": 2051,
	"./img/registration-mobile-6.webp": 2052,
	"./img/registration-mobile-6@2x.webp": 2053,
	"./img/renessans-mobile.webp": 2054,
	"./img/renessans-mobile@2x.webp": 2055,
	"./img/reviews-author-11.webp": 2056,
	"./img/reviews-author-11@2x.webp": 2057,
	"./img/reviews-author-12.webp": 2058,
	"./img/reviews-author-12@2x.webp": 2059,
	"./img/reviews-author-13.webp": 2060,
	"./img/reviews-author-13@2x.webp": 2061,
	"./img/reviews-author-14.webp": 2062,
	"./img/reviews-author-14@2x.webp": 2063,
	"./img/reviews-author-15.webp": 2064,
	"./img/reviews-author-16.webp": 2065,
	"./img/reviews-author-17.webp": 2066,
	"./img/reviews/review-photo-1.webp": 1057,
	"./img/reviews/review-photo-2.webp": 2067,
	"./img/rgau-reply.webp": 2068,
	"./img/rgau.webp": 2069,
	"./img/rusagro-mobile.webp": 2070,
	"./img/rusagro-mobile@2x.webp": 2071,
	"./img/schuco-mobile.webp": 2072,
	"./img/schuco-mobile@2x.webp": 2073,
	"./img/support-promo-bg-900-599.webp": 1251,
	"./img/support-promo-bg.webp": 1252,
	"./img/support/bitmap.webp": 1123,
	"./img/support/logo1.webp": 2074,
	"./img/support/project1.webp": 2075,
	"./img/support/sp-img1.webp": 2076,
	"./img/support/sp-img2.webp": 2077,
	"./img/tariffs/logo-comdi.webp": 2078,
	"./img/tariffs/logo-webinar-enterprise.webp": 2079,
	"./img/tariffs/logo-webinar.webp": 2080,
	"./img/tariffs/mts-tab-comdi-img.webp": 2081,
	"./img/tariffs/product-detail-promo-bg.webp": 797,
	"./img/task/common-healthcare/form_image.webp": 507,
	"./img/task/common-healthcare/form_image_mobile.webp": 537,
	"./img/task/common-healthcare/form_image_tablet.webp": 538,
	"./img/task/common-healthcare/image_1.webp": 606,
	"./img/task/common-healthcare/image_10.webp": 2082,
	"./img/task/common-healthcare/image_11.webp": 607,
	"./img/task/common-healthcare/image_11_mobile.webp": 608,
	"./img/task/common-healthcare/image_12.webp": 2083,
	"./img/task/common-healthcare/image_1_mobile.webp": 609,
	"./img/task/common-healthcare/image_2.webp": 798,
	"./img/task/common-healthcare/image_2_mobile.webp": 799,
	"./img/task/common-healthcare/image_3.webp": 1253,
	"./img/task/common-healthcare/image_3_mobile.webp": 1254,
	"./img/task/common-healthcare/image_4.webp": 800,
	"./img/task/common-healthcare/image_4_mobile.webp": 801,
	"./img/task/common-healthcare/image_5.webp": 1255,
	"./img/task/common-healthcare/image_5_mobile.webp": 1256,
	"./img/task/common-healthcare/image_5_tablet.webp": 1257,
	"./img/task/common-healthcare/image_6.webp": 1258,
	"./img/task/common-healthcare/image_6_mobile.webp": 1259,
	"./img/task/common-healthcare/image_6_tablet.webp": 1260,
	"./img/task/common-healthcare/image_7.webp": 1261,
	"./img/task/common-healthcare/image_7_mobile.webp": 1262,
	"./img/task/common-healthcare/image_7_tablet.webp": 1263,
	"./img/task/common-healthcare/image_8.webp": 802,
	"./img/task/common-healthcare/image_8_mobile.webp": 803,
	"./img/task/common-healthcare/image_9.webp": 2084,
	"./img/task/common-healthcare/pic_1.webp": 804,
	"./img/task/common-healthcare/pic_2.webp": 1264,
	"./img/task/common-healthcare/pic_3.webp": 539,
	"./img/task/education/boards_1_1920.webp": 1124,
	"./img/task/education/boards_2_1920.webp": 1125,
	"./img/task/education/devices_1_1920.webp": 1126,
	"./img/task/education/devices_1_375.webp": 1127,
	"./img/task/education/devices_1_768.webp": 1128,
	"./img/task/education/devices_2_1920.webp": 1129,
	"./img/task/education/devices_2_375.webp": 1130,
	"./img/task/education/devices_2_768.webp": 1131,
	"./img/task/education/devices_3_1920.webp": 1132,
	"./img/task/education/devices_3_375.webp": 1133,
	"./img/task/education/devices_3_768.webp": 1134,
	"./img/task/education/form_1920.webp": 725,
	"./img/task/education/services_1_1920.webp": 726,
	"./img/task/education/tools_chats_1920.webp": 1135,
	"./img/task/education/tools_chats_768.webp": 1136,
	"./img/task/education/tools_meetings_1920.webp": 1137,
	"./img/task/education/tools_meetings_768.webp": 1138,
	"./img/task/education/who-is-suitable_1_1920.webp": 1139,
	"./img/task/education/who-is-suitable_2_1920.webp": 1140,
	"./img/task/education/who-is-suitable_3_1920.webp": 1141,
	"./img/task/healthcare/board_1.webp": 1265,
	"./img/task/healthcare/board_2.webp": 1266,
	"./img/task/healthcare/board_3.webp": 1267,
	"./img/task/healthcare/board_4.webp": 1268,
	"./img/task/healthcare/form-image.webp": 1142,
	"./img/task/healthcare/image.webp": 1269,
	"./img/task/healthcare/image_mobile.webp": 1270,
	"./img/task/healthcare/image_tablet.webp": 1271,
	"./img/task/healthcare/integration_1.webp": 1272,
	"./img/task/healthcare/integration_2.webp": 1273,
	"./img/task/healthcare/integration_3.webp": 1274,
	"./img/task/healthcare/know-more.webp": 1275,
	"./img/task/healthcare/promo.webp": 1276,
	"./img/task/healthcare/promo_mobile.webp": 1277,
	"./img/task/healthcare/promo_tablet.webp": 1278,
	"./img/task/healthcare/software_1.webp": 508,
	"./img/task/healthcare/software_2.webp": 509,
	"./img/task/med/alternate_1.webp": 1279,
	"./img/task/med/alternate_1_mobile.webp": 2085,
	"./img/task/med/alternate_1_tablet.webp": 1280,
	"./img/task/med/alternate_2.webp": 1281,
	"./img/task/med/alternate_2_mobile.webp": 2086,
	"./img/task/med/alternate_2_tablet.webp": 1282,
	"./img/task/med/alternate_3.webp": 1283,
	"./img/task/med/alternate_3_mobile.webp": 2087,
	"./img/task/med/alternate_3_tablet.webp": 1284,
	"./img/task/med/promo.webp": 1285,
	"./img/task/med/promo_mobile.webp": 1286,
	"./img/task/med/promo_pic.webp": 2088,
	"./img/task/nmo/image_1.webp": 1287,
	"./img/task/nmo/image_1_mobile.webp": 1288,
	"./img/task/nmo/image_2.webp": 610,
	"./img/task/nmo/image_3.webp": 805,
	"./img/task/nmo/promo.webp": 1289,
	"./img/task/nmo/promo_mobile.webp": 1290,
	"./img/task/nmo/promo_tablet.webp": 2089,
	"./img/task/ouz/image_1.webp": 1291,
	"./img/task/ouz/image_2.webp": 1292,
	"./img/task/ouz/image_3.webp": 1293,
	"./img/task/ouz/image_4.webp": 1294,
	"./img/task/ouz/image_5.webp": 1295,
	"./img/task/ouz/image_6.webp": 1296,
	"./img/task/ouz/image_6_mobile.webp": 1297,
	"./img/task/ouz/image_6_tablet.webp": 1298,
	"./img/task/ouz/promo.webp": 1299,
	"./img/task/ouz/promo_mobile.webp": 1300,
	"./img/task/ouz/promo_pic.webp": 2090,
	"./img/task/pharma/image_1.webp": 1301,
	"./img/task/pharma/image_1_mobile.webp": 1302,
	"./img/task/pharma/image_2.webp": 1303,
	"./img/task/pharma/image_2_tablet.webp": 1304,
	"./img/task/pharma/image_3.webp": 1305,
	"./img/task/pharma/image_4.webp": 1306,
	"./img/task/pharma/image_5.webp": 1307,
	"./img/task/pharma/image_6.webp": 1308,
	"./img/task/pharma/image_6_mobile.webp": 1309,
	"./img/task/pharma/promo.webp": 1310,
	"./img/task/pharma/promo_mobile.webp": 1311,
	"./img/task/pharma/promo_pic.webp": 2091,
	"./img/task/pharma/promo_tablet.webp": 1312,
	"./img/training-courses.webp": 2092,
	"./img/training-courses@2x.webp": 2093,
	"./img/training-manual.webp": 2094,
	"./img/training-manual@2x.webp": 1059,
	"./img/why-choose/why-choose-bg-900-735.webp": 2095,
	"./img/why-choose/why-choose-bg.webp": 2096,
	"./new-design/img/coin/manual-coin.webp": 2148,
	"./new-design/img/error/error-404.webp": 231,
	"./new-design/img/error/error-410.webp": 232,
	"./new-design/img/form/form-error.webp": 2100,
	"./new-design/img/form/form-success.webp": 2101,
	"./new-design/img/index/promo/product-card-bg.webp": 2196,
	"./new-design/img/index/promo/promo-bg--1920.webp": 2197,
	"./new-design/img/index/promo/promo-bg--768.webp": 2198,
	"./new-design/img/index/promo/promo-bg--991.webp": 2149,
	"./new-design/img/products/coin/boards-coin.webp": 2199,
	"./new-design/img/products/coin/comdi-coin.webp": 2200,
	"./new-design/img/products/coin/equipment-coin.webp": 2201,
	"./new-design/img/products/coin/forms-coin.webp": 2202,
	"./new-design/img/products/coin/meetings-coin.webp": 2203,
	"./new-design/img/products/coin/messengers-coin.webp": 2204,
	"./new-design/img/products/coin/task-management-coin.webp": 2205,
	"./new-design/img/products/coin/webinars-coin.webp": 2206,
	"./new-design/img/products/coin/westudy-coin.webp": 2207,
	"./new-design/img/products/common/additional-products/boards.webp": 2150,
	"./new-design/img/products/common/additional-products/forms.webp": 2151,
	"./new-design/img/products/westudy/advantages/advantages-bg--375.webp": 2152,
	"./new-design/img/products/westudy/advantages/advantages-bg--767.webp": 2153,
	"./new-design/img/products/westudy/advantages/advantages-bg--991.webp": 2154,
	"./new-design/img/products/westudy/advantages/advantages-bg.webp": 2208,
	"./new-design/img/products/westudy/feature-preview/certificates.webp": 2316,
	"./new-design/img/products/westudy/feature-preview/course-editor.webp": 2317,
	"./new-design/img/products/westudy/feature-preview/learning-analytics.webp": 2318,
	"./new-design/img/products/westudy/feature-preview/lesson-formats.webp": 2319,
	"./new-design/img/products/westudy/feature-preview/mixed-learning.webp": 2320,
	"./new-design/img/products/westudy/feature-preview/news-feed.webp": 2321,
	"./new-design/img/products/westudy/feature-preview/paid-learning.webp": 2322,
	"./new-design/img/products/westudy/feature-preview/scorm-courses.webp": 2323,
	"./new-design/img/products/westudy/feature-preview/tests-and-surveys.webp": 2324,
	"./new-design/img/products/westudy/form/form-bg--767.webp": 2155,
	"./new-design/img/products/westudy/form/form-bg--991.webp": 2156,
	"./new-design/img/products/westudy/form/form-bg.webp": 2209,
	"./new-design/img/products/westudy/promo/promo-bg--579.webp": 2210,
	"./new-design/img/products/westudy/promo/promo-bg--767.webp": 2211,
	"./new-design/img/products/westudy/promo/promo-bg--991.webp": 2212,
	"./new-design/img/products/westudy/promo/promo-bg.webp": 2325,
	"./new-design/img/products/westudy/tariffs/tariff-selection-bg--1199.webp": 2213,
	"./new-design/img/products/westudy/tariffs/tariff-selection-bg--375.webp": 2214,
	"./new-design/img/products/westudy/tariffs/tariff-selection-bg--767.webp": 2215,
	"./new-design/img/products/westudy/tariffs/tariff-selection-bg--991.webp": 2216,
	"./new-design/img/products/westudy/tariffs/tariff-selection-bg.webp": 2326,
	"./new-design/img/reviews/ego-university.webp": 2217,
	"./new-design/img/reviews/kladovaya-zdorovya.webp": 2218,
	"./new-design/img/reviews/sodeystvie.webp": 2219,
	"./new-design/img/reviews/tek-torg.webp": 2220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 770;